"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggles = exports.TogglesProvider = void 0;
const tslib_1 = require("tslib");
const toggles_service_1 = require("./toggles.service");
class TogglesProvider {
    constructor() {
        this.defaultTogglesService = TogglesProvider.getDefaultTogglesService();
    }
    static getInstance() {
        if (!TogglesProvider.instance) {
            TogglesProvider.instance = new TogglesProvider();
        }
        return TogglesProvider.instance;
    }
    get(toggleName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let executor = this.delegatedTogglesService;
            if (!executor) {
                executor = this.defaultTogglesService;
            }
            return executor.get(toggleName);
        });
    }
    isActive(toggleName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let executor = this.delegatedTogglesService;
            if (!executor) {
                executor = this.defaultTogglesService;
            }
            return executor.isActive(toggleName);
        });
    }
    getAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let executor = this.delegatedTogglesService;
            if (!executor) {
                executor = this.defaultTogglesService;
            }
            return executor.getAll();
        });
    }
    registerToggleProviderDelegate(toggleProviderDelegate) {
        this.delegatedTogglesService = toggleProviderDelegate || TogglesProvider.getDefaultTogglesService();
    }
    static getDefaultTogglesService() {
        // @ts-ignore
        let togglesService = window[TogglesProvider.GLOBAL_TOGGLES_PROVIDER];
        if (!togglesService) {
            togglesService = new toggles_service_1.TogglesService();
            // @ts-ignore
            window[TogglesProvider.GLOBAL_TOGGLES_PROVIDER] = togglesService;
        }
        return togglesService;
    }
}
exports.TogglesProvider = TogglesProvider;
TogglesProvider.GLOBAL_TOGGLES_PROVIDER = 'togglesService';
exports.Toggles = TogglesProvider.getInstance();
//# sourceMappingURL=toggles-provider.js.map